import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { Typography, Card, CardContent, Grid, Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import SaveIcon from '@material-ui/icons/Save';
import UpdateIcon from '@material-ui/icons/Update';
import Controls from '../controls/Controls';

import { useConstantsContext } from '../../context/constants_context';
import { useClientContext } from '../../context/client_context';
import { baseUrl } from '../../utils/constants';

export default function Address() {
  const { provinces } = useConstantsContext();
  const { clientRefId, clientAddress, setClientAddress } = useClientContext();
  const [formData, setFormData] = useState(null);

  const AddressDetailsSchema = Yup.object().shape({
    addressLine1: Yup.string().min(2, 'Address is too Short!').max(50, 'Address is too Long!'),
    provinceLookupKey: Yup.string().required('Province is required')
  });
  //   console.log('current address  at enter', clientAddress);

  //   const initialValue = {
  //     addressLine1: clientAddress.addressLine1,
  //     addressLine2: clientAddress.addressLine2,
  //     addressLine3: clientAddress.addressLine3,
  //     provinceLookupKey: clientAddress.provinceLookupKey,
  //     postalCode: clientAddress.postalCode,
  //     owningRefId: clientAddress.owningRefId
  //   };

  //   useEffect(() => {
  //     setFormData(initialValue);
  //   }, [clientRefId]);

  const formik = useFormik({
    initialValues: clientAddress,
    enableReinitialize: true,
    validationSchema: AddressDetailsSchema,
    onSubmit: (values) => {
      console.log('custingo before that exe 2', values);
      handleFormUpdate(values);
    }
  });

  const handleFormUpdate = (e) => {
    e.owningRefId = clientRefId;
    saveClientData(e);
  };

  const saveClientData = (e) => {
    const jsonClient = [];
    jsonClient.push(e);
    console.log('address stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/addAddress`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          //   setClientRefId(result.refId);
          setClientAddress(result);
          <Alert variant="filled" severity="success">
            Client Saved Successfully!
          </Alert>;
        },
        (error) => {
          <Alert variant="filled" severity="error">
            Error in Saving Client!, {error}
          </Alert>;
        }
      );
  };

  return (
    <Card>
      <CardContent>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate>
            <Typography variant="h6" gutterBottom>
              Address...
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Controls.Input name="addressLine1" label="Address line 1" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controls.Input name="addressLine2" label="Address line 2" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="addressLine3" label="City" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="postalCode" label="Postal Code" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.SelectJson
                  name="provinceLookupKey"
                  label="Province"
                  options={provinces}
                />
              </Grid>
              {/* <Grid item xs={8} container spacing={2} justifyContent="center" alignItems="center">
                <Controls.Button>Submit Address</Controls.Button>
              </Grid> */}
              <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
                <Grid item xs={12} sm={1} marginRight={1}>
                  <Controls.Button type="submit" variant="contained" startIcon={<SaveIcon />}>
                    Save...
                  </Controls.Button>
                </Grid>
                <Grid item xs={12} sm={1}>
                  <Button
                    variant="outlined"
                    startIcon={<UpdateIcon />}
                    // onClick={() => handleNewClient()}
                  >
                    Update
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </CardContent>
    </Card>
  );
}
